var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-card',[_c('alter-form',{attrs:{"watchImageVisible":false,"formData":_vm.formData,"collapseLength":_vm.collapseLength},on:{"isComplete":_vm.isComplete,"formSubmit":_vm.formSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }